import type { QuoteFile } from 'paintscout'
import { getUploadedFiles } from '../../util/uploadedFiles'

/**
 * Appends every usable file in `incoming` to a gallery's `fields.files`, preserving the order they
 * were picked/uploaded in. Returns the existing array untouched when `incoming` holds nothing
 * usable, so a wholly-failed upload can't mark the presentation dirty with an identical value.
 */
export function appendGalleryFiles(existing: QuoteFile[] | undefined, incoming: unknown[]): QuoteFile[] {
  const current = Array.isArray(existing) ? existing : []
  const newFiles = getUploadedFiles(incoming)

  if (!newFiles.length) return current

  return [...current, ...newFiles]
}
